import type { Role } from '@conversia/shared-types';

/**
 * EL FRENO DE LAS ACCIONES QUE DEJAN AL NEGOCIO SIN WHATSAPP.
 *
 * Desconectar el canal, ponerlo en entrenamiento o borrarlo son un clic, y
 * cualquiera de los tres deja a los clientes sin respuesta sin que nadie se
 * entere. El 22-sep-2026, el primer día con el número del cliente, una
 * vinculación se cerró desde el teléfono y el negocio estuvo veinte minutos
 * mudo.
 *
 * Regla de Esteban: el súper administrador (OWNER) somos nosotros y seguimos
 * con una confirmación normal. Cualquier otro —incluida la encargada, que es
 * ADMIN— tiene que ESCRIBIR el nombre del canal para poder seguir. El botón de
 * confirmar queda apagado hasta que lo escriba igual.
 *
 * PURO: sin estado, sin red. Es solo la regla.
 */
export type AccionPeligrosa = 'desconectar' | 'entrenar' | 'eliminar';

export function exigeEscribirNombre(rol: Role | undefined | null): boolean {
  return rol !== 'OWNER';
}

export interface TextoDeAccion {
  titulo: string;
  advertencia: string;
  botón: string;
}

export function textoDeAccion(accion: AccionPeligrosa, canal: string): TextoDeAccion {
  switch (accion) {
    case 'desconectar':
      return {
        titulo: 'Desconectar el WhatsApp',
        advertencia: `Vas a desconectar «${canal}». Desde ese momento los clientes que escriban NO reciben respuesta y los avisos a los vendedores no salen. Para volver, casi siempre hay que escanear un código QR con el teléfono.`,
        botón: 'Sí, desconectar',
      };
    case 'entrenar':
      return {
        titulo: 'Poner el canal en entrenamiento',
        advertencia: `Vas a callar a la asistente en TODO el canal «${canal}». Los clientes seguirán escribiendo y nadie les va a contestar hasta que una persona lo haga a mano.`,
        botón: 'Sí, callar la asistente',
      };
    case 'eliminar':
      return {
        titulo: 'Eliminar el canal',
        advertencia: `Vas a eliminar «${canal}». Se pierde la conexión con ese WhatsApp y hay que volver a vincularlo con un código QR. Las conversaciones quedan como histórico.`,
        botón: 'Sí, eliminar',
      };
  }
}

/** ¿Se puede confirmar ya? Con el nombre escrito igual (sin importar mayúsculas). */
export function puedeConfirmar(
  rol: Role | undefined | null,
  canal: string,
  escrito: string,
): boolean {
  if (!exigeEscribirNombre(rol)) return true;
  return escrito.trim().toLowerCase() === canal.trim().toLowerCase() && canal.trim() !== '';
}
